export const DEFAULT_PAGE_SIZE = 20;
export const PATIENTS_LIST_PAGE_SIZE = 20;
export const TEAM_MEMBERS_PAGE_SIZE = 20;
export const AUDITING_PAGE_SIZE = 10;
export const DIAGNOSTICS_PAGE_SIZE = 20;
